import { Avatar, ModalFullscreen, Overline, UIHeading4, UIText1 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './TourModal.css';
import { TourWidget } from '../TourWidget';

interface ITourModalProps {
  tourUrl: string;
  project: {
    name: string;
    startPrice?: string;
    endPrice?: string;
  };
  builder: {
    logo: string;
    name: string;
  };
  contactsButton: React.ReactNode;
  callbackButton: React.ReactNode;
  onClose(): void;
}

export const TourModal: React.FC<ITourModalProps> = ({
  tourUrl,
  project: { startPrice, endPrice, name: projectName },
  builder: { logo, name: builderName },
  contactsButton,
  callbackButton,
  onClose,
}) => {
  return (
    <ModalFullscreen open={true} onClose={onClose} theme="white">
      <div className={styles['container']} data-name="TourModal">
        <div className={styles['close-button']} onClick={onClose}>
          <IconActionClose16 display="block" />
        </div>
        <div className={styles['main']}>
          <TourWidget url={tourUrl} />
        </div>
        <div className={styles['aside']}>
          <UIText1>Проект дома «{projectName}»</UIText1>
          <div className={styles['price']}>
            {startPrice} <br /> {endPrice}
          </div>
          <div className={styles['actions']}>
            {contactsButton}
            {callbackButton}
          </div>
          <div className={styles['builder']}>
            <Avatar size={70} type="builder" src={logo}></Avatar>
            <div>
              <Overline color="icon-secondary-default">СТРОИТЕЛЬНАЯ КОМПАНИЯ</Overline>
              <UIHeading4>{builderName}</UIHeading4>
            </div>
          </div>
        </div>
      </div>
    </ModalFullscreen>
  );
};
